import { render } from "./LocalUso.vue?vue&type=template&id=33b32fc8"
import script from "./LocalUso.vue?vue&type=script&lang=js"
export * from "./LocalUso.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__